
import Header from '../../components/Header'
import EventTable from './CollapisbleTable/EventTable'
import BoxWrapper from '../../components/BoxWrapper/BoxWrapper'

const Events = ({ header }) => {
  // 🔑 Centralized state for filters & search


  return (
    <>
      <Header header={header} />

      <BoxWrapper>

        <EventTable

        />

      </BoxWrapper>
    </>
  )
}

export default Events
